'use client';

import {lazy, Suspense, useEffect, useState} from 'react';

const NavigationProgressBar = lazy(() => import("@/components/layouts/progress-bar").then(mod => ({default: mod.NavigationProgressBar})));
const GoogleTagManagerScripts = lazy(() => import("@/components/cookie-consent/google-tag-manager-scripts").then(mod => ({default: mod.GoogleTagManagerScripts})));
const TurnstileProvider = lazy(() => import('@/components/turnstile/turnstile-provider'));
const OutboundClickTracker = lazy(() => import("@/components/tracking/outbound-click-tracker").then(mod => ({default: mod.OutboundClickTracker})));
const NavigationContextTracker = lazy(() => import("@/components/navigation/navigation-context-tracker.client").then(mod => ({default: mod.NavigationContextTracker})));

export function ClientOnlyProviders() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);

    if (!mounted) return null;

    return (
        <Suspense fallback={null}>
            <NavigationProgressBar/>
            <NavigationContextTracker/>
            <GoogleTagManagerScripts/>
            <OutboundClickTracker/>
            <TurnstileProvider/>
        </Suspense>
    );
}
